import React from 'react';
import {CgArrowRight, CgArrowLeft} from 'react-icons/cg';
import {Save, Excel, Download, Plus, UploadImage, Done, Trash, ThumbsDown, ThumbsUp} from '../../assets/icons/icons';
import {ButtonContainer, ButtonIcon, ButtonSpan} from './styles';

export default ({
  title,
  callback,
  lColor,
  rColor,
  fColor = '#ffffff',
  bColor = 'transparent',
  icon,
  rIcon,
  lMargin = '0 10px',
  rMargin = '0 20px',
  xMargin = '0 0 0 10px',
  fullWidth,
}: {
  title?: string;
  callback: any;
  lColor: string;
  rColor: string;
  icon?: string;
  rIcon?: string;
  lMargin?: string;
  rMargin?: string;
  fColor?: string;
  bColor?: string;
  xMargin?: string;
  fullWidth?: boolean;
}) => (
  <ButtonContainer onClick={callback} bColor={bColor} xMargin={xMargin}>
    <ButtonIcon lColor={lColor} lMargin={lMargin}>
      {icon === 'save' ? (
        <Save color={fColor} />
      ) : icon === 'excel' ? (
        <Excel color={fColor} />
      ) : icon === 'plus' ? (
        <Plus />
      ) : icon === 'done' ? (
        <Done />
      ) : icon === 'trash' ? (
        <Trash color={fColor} />
      ) : icon === 'arrowLeft' ? (
        <CgArrowLeft color={fColor} fontSize="25px" />
      ) : icon === 'uploadImage' ? (
        <UploadImage />
      ): icon === 'thumbsDown' ? (
        <ThumbsDown />
      ): icon === 'thumbsUp' ? (
        <ThumbsUp />
      ): rIcon ? (
        <ButtonSpan fColor={fColor}>{title}</ButtonSpan>
      ) : (
        <></>
      )}
    </ButtonIcon>
    <ButtonSpan fullWidth={fullWidth} rColor={rColor} rMargin={rMargin} fColor={fColor}>
      {!rIcon ? (
        title
      ) : (
        <>
          {rIcon === 'download' ? (
            <Download color={fColor} />
          ) : rIcon === 'arrowRight' ? (
            <CgArrowRight color={fColor} fontSize="25px" />
          ) : (
            title
          )}
        </>
      )}
    </ButtonSpan>
  </ButtonContainer>
);
